import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";

import ArticleSearch from "../components/ArticleSearch";
const News = () => {
  useTitle("- News");

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
            <h1 className="mt-5 event-heading-start">News.</h1>
            <p className="event-sub-text mb-3">Latest news and updates from our community.</p>

            <div className="filter-section mb-5"></div>

            <ArticleSearch />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default News;
